/**
 * @format
 * @Description: Header导航状态机
 * @Autho: 人杰
 * @Date:2019/10/18 11:47
 */

import { observable, action, computed, useStrict, runInAction } from 'mobx';
import { message } from 'antd';
import Cookie from 'js-cookie';
import Serv from './HeaderNavServ';
import { map, get } from 'lodash';
useStrict(true);
class HeaderNavMod {
  /** 导航数据源 */
  @observable
  dataSource = [];
  @observable
  appList = [];

  @observable
  appInsName = '请选择应用切换';

  @action
  setAppList(val) {
    this.appList = val || [];
  }
  @action
  setAppInsName(val) {
    this.appInsName = val;
  }

  @action
  appChange({ item = {}, AppStore = {}, history = {} }) {
    this.setAppInsName(item.appInsName);
    if (item.status == 0) {
      message.warn('该应用已被禁用!');
    } else if (item.code == 'BOC') {
      history.push('/productList');
    }else if (item.jumpType + '' == '2') {
      window.open(`${item.hostName}?boc_auth=${Cookie.get('boc_auth')}&&childrenAppLogo=${item.logoUrl}`, '_blank'); 
    } else {
      Cookie.set('childSystemLink', item.hostName);
      Cookie.set('childSystemApplicationKey', item.appKey);
      Cookie.set('childrenInstanceId', item.id);
      Cookie.set('childrenAppInsName', item.appInsName);
      Cookie.set('childrenAppLogo', item.logoUrl);
      AppStore.setChildSystemLink(item.hostName);
      AppStore.setChildSystemApplicationKey(item.appKey);
      history.push('/productDetail');
    }
  }
  
  @action
  clickNotice({ item = {}, AppStore = {}, history = {}, info = {}, isInfo = false }) {
    if(!get(item, 'webInstance')){
      message.warn('还没有配置该栏位或报表');
      return
    }
    map(this.appList, item1 => {
      if (item1.id == get(item, 'webInstance')) {
        try {
          let location = new URL(item1.hostName);
          if (location) {
            let hash = isInfo ?get(info,'webUrl'): get(item, 'webUrl')
            item1.hostName = location.origin + location.pathname + '#' + hash;
          }
          if (new URL(item1.hostName)) {
            this.appChange({ item: item1, AppStore, history });
          }
        } catch (e) {
          message.warn('配置的跳转地址不正确');
        }
      }
    });
  }

  @action
  fetchData() {
    this.dataSource = [
      {
        value: '泰啤运营平台',
        url: '1'
      },
      {
        value: '全渠道销售',
        url: 'http://wxdev.dtyunxi.cn/i-dc-p/icommerce-operations-web-pc/#/system/usermgmt'
      },
      {
        value: '营销智能',
        url: 'http://wxdev.dtyunxi.cn/i-dc-p/imarketing-operations-web-pc/#/'
      },
      {
        value: '智能客服',
        url: 'http://wxdev.dtyunxi.cn/i-dc-p/iservice-operation-web-pc/#/home/index/index?_k=j4cguy'
      }
    ];
  }

  @action getAppList = async payload => {
    // 请求参数
    let params = payload;
    // 异步请求方法
    let { data } = await Serv.getAppList(params);
    // 使用lodash的get方法获取嵌套对象属性，避免当data为null时导致的data.list为undefined报错
    // 设置到状态机 - 如果是异步，必须在runInAction
    runInAction(() => {});

    return data;
  };
}

// ES6单例写法
export default new HeaderNavMod();



// WEBPACK FOOTER //
// ./src/widget/HeaderNav/HeaderNavMod.js